/** Set by Vite at build time (vite.config.ts `define`): APP_VERSION from the environment, else the commit, else `dev`. */
declare const __MAKAN_VERSION__: string | undefined;

/** The build of the command center this page runs, for a bug report. */
export const APP_VERSION: string = typeof __MAKAN_VERSION__ === 'string' ? __MAKAN_VERSION__ : 'dev';
